// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1uDmW","file":"styles_file__3u7uS"};